export default __webpack_public_path__ + "static/media/tomate.32eae835.png";